import { useWidgetContext } from '@widget/core';
import { ThankYouStepComponent } from './ThankYouStepComponent';
import { useTimeslots } from '@widget/core/TimeSlotsProvider';

import type { ThankYouStepProps } from './ThankYouStepComponent';

export const ThankYouStep = (props: ThankYouStepProps): JSX.Element => {
  const widget = useWidgetContext();
  const formData = widget.getFormData();

  const alReadyBookedSlot =
    widget.leadData?.bookedSlot?.isNewAppointment === false
      ? {
          ...widget.leadData.bookedSlot,
          phone: widget.leadData.customerContact?.phone || '', //@todo replace with correct data from booked slot or remove
          address: `${formData?.streetAndNumber ? formData?.streetAndNumber + ',' : ''} ${
            formData?.zipCode || ''
          }, ${formData?.city || ''}`, //@todo replace with correct data from booked slot or remove
        }
      : null;
  const isPhoneLinkExist =
    props?.phoneLink && props.phoneLink.phoneCtaText && props.phoneLink.phoneCtaTel;
  const phoneCta = isPhoneLinkExist
    ? {
        target: props.phoneLink?.phoneCtaTarget || '',
        tel: props.phoneLink?.phoneCtaTel || '',
        text: props.phoneLink?.phoneCtaText || '',
      }
    : null;

  const { timeslots } = useTimeslots();
  const showPhoneLink =
    !timeslots?.OnSite && !timeslots?.Call && !!phoneCta?.text && !!phoneCta?.target;

  return (
    <ThankYouStepComponent
      phoneCta={phoneCta}
      {...props}
      alReadyBookedSlot={alReadyBookedSlot}
      showPhoneLink={showPhoneLink}
    />
  );
};
